module.exports = __webpack_public_path__ + "img/find-new-fans.3db8b480.jpg";